module.exports = __webpack_public_path__ + "static/media/sf_1900_gray.77c8ff01015174f8eeb8ddf7e551e832.png";